import { LOCAL_STORAGE_INGRESS_PATH_KEY } from 'shared/consts/localStorage';

export const setIngressPath = (path: string) => {
  localStorage.setItem(LOCAL_STORAGE_INGRESS_PATH_KEY, path);
};

export const getIngressPath = () => localStorage.getItem(LOCAL_STORAGE_INGRESS_PATH_KEY);

export const clearIngressPath = () => {
  localStorage.removeItem(LOCAL_STORAGE_INGRESS_PATH_KEY);
};
